import { theme } from 'antd';
import { AlertTriangle, CheckCircle, Info } from 'lucide-react';
import React, { ReactElement } from 'react';
import i18n from 'src/i18n';
import { NotificationDataSummary, NotificationType } from 'src/stores/notifications-store';

const { getDesignToken } = theme;

export type NotificationDisplayInformation = {
  title: string;
  description: string;
  path?: string;
  navigationState?: Record<string, string>;
  icon: ReactElement;
};

export function getNotificationDisplayInformation(
  notification: NotificationDataSummary,
  displayError: boolean = false
): NotificationDisplayInformation {
  const globalToken = getDesignToken();

  const t = i18n.t;
  const title = t(`${notification.type}NotificationTitle${notification.error ? 'Error' : ''}`);
  let description = t(`${notification.type}NotificationDescription${notification.error ? 'Error' : ''}`)
    .replace('{A}', notification.relatedEntityName)
    .replace('{B}', notification.redirectEntityName)
    .replace('{X}', `${notification.count}`);

  if (displayError && notification.error) {
    description = `${description} ${t('Error')}: ${notification.error}`;
  }

  let path: string | undefined = undefined;
  let navigationState: Record<string, string> = {};

  let icon;

  if (notification.error) {
    icon = <AlertTriangle size={18} style={{ color: globalToken.colorError }} />;
  } else {
    switch (notification.type) {
      case NotificationType.OrganizationCreationFinished:
      case NotificationType.OrganizationIsAvailable:
      case NotificationType.ToolUsageReport:
        icon = <CheckCircle size={18} style={{ color: globalToken.colorSuccess }} />;
        break;
      case NotificationType.OrganizationExpirationWarning:
        icon = <AlertTriangle size={18} style={{ color: globalToken.colorWarning }} />;
        break;
      default:
        icon = <Info size={18} />;
    }
  }

  switch (notification.type) {
    case NotificationType.LicenseNeedsApproval: {
      path = `/licenses/${notification.redirectEntityId}`;
      break;
    }

    case NotificationType.LicenseWasRenewed: {
      path = `/licenses/${notification.redirectEntityId}`;
      break;
    }

    case NotificationType.OrganizationCreationFinished: {
      path = notification.error ? undefined : `/organizations/${notification.redirectEntityId}`;
      break;
    }

    case NotificationType.OrganizationExpirationWarning: {
      path = `/organizations/${notification.redirectEntityId}`;
      break;
    }

    case NotificationType.OrganizationIsAvailable: {
      path = notification.error ? undefined : `/organizations/${notification.redirectEntityId}`;
      break;
    }
  }

  return { title, description, path, navigationState, icon };
}
